<template>
  <o-form-wrapper
    v-model="item"
    :server-errors="_se"
    :v="$v.item"
    :schema="schema"
    :form-state="formState"
  >
    <o-working-overlay :working="working"></o-working-overlay>
    <o-widget-wrapper
      :schema="schema"
      name="job"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <job-search
        v-model="item.job"
        :form-state="formState"
        name="job"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.job"
        @update-job="updateJob"
        :create="create"
        :address="item.site_address"
        :suburb="item.suburb"
        :job_number="item.job_number"
        :job-item="selectedJob"
      >
      </job-search>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="date_received"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-date-time
        disabled
        v-model="getCurrentDate"
        name="date_received"
        v-bind="schema.fields.date_received"
        :form-state="formState"
        :validators="$v.item"
        :server-errors="_se"
        hide-time
      ></o-date-time>
    </o-widget-wrapper>
    <o-widget-wrapper
      :schema="schema"
      name="site_address"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        v-model="item.site_address"
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="site_address"
        v-bind="schema.fields.site_address"
        readonly
      ></o-text-field>
    </o-widget-wrapper>
    <o-widget-wrapper
      :schema="schema"
      name="builder"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        :value="item.builder__name || item.job__customer__name"
        :items="optionCustomerItems"
        text-field="name"
        value-field="id"
        sort-field="name"
        :form-state="formState"
        :loading="optionCustomerWorking"
        name="builder__name"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.builder__name"
        readonly
      >
      </o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="supervisor"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-select
        label="Requesting Supervisor"
        disabled
        v-model="getSupervisor"
        :items="optionSupervisorItems"
        text-field="name"
        value-field="id"
        sort-field="name"
        :form-state="formState"
        :loading="optionSupervisorWorking"
        name="supervisor"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.supervisor"
        store-name="Supplier"
      >
      </o-select>
      <!-- <o-text-field

        v-model="item.supervisor_name"
        :form-state="formState"
        name="supervisor"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.supervisor"
      >
      </o-text-field> -->
    </o-widget-wrapper>
    <b-container fluid="xs">
      <b-row>
        <b-col class="text-right pr-0">Note: </b-col>
        <b-col cols="10">
          <b>Must allow at least 3 work days to complete repair</b>
        </b-col>
      </b-row>
    </b-container>
    <br />
    <o-widget-wrapper
      :schema="schema"
      name="description"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-area
        v-model="item.description"
        :form-state="formState"
        name="description"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.description"
      ></o-text-area>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="want_date"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-date-time
        v-model="item.want_date"
        name="want_date"
        v-bind="schema.fields.want_date"
        :form-state="formState"
        :validators="$v.item"
        :server-errors="_se"
        hide-time
      ></o-date-time>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="engineering_required"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-checkbox
        v-model="item.engineering_required"
        :form-state="formState"
        name="engineering_required"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.engineering_required"
      ></o-checkbox>
    </o-widget-wrapper>
    <b-container fluid="xs" class="my-2">
      <b-row>
        <b-col
          cols="2"
          class="text-right pr-0 d-flex justify-content-end align-items-center pt-10px"
        >
          <p>
            {{
              item.engineering_required
                ? "Upload Engineering Diagram (atleast 3 photos) Includes Marked up Plan*"
                : "Upload Engineering Diagram (atleast 2 photos)*"
            }}
          </p>
        </b-col>
        <b-col
          cols="9"
          class="p-3 ml-2 d-flex flex-row justify-content-between align-items-center"
        >
          <b-container fluid="xs" class="my-2 w-100">
            <b-container class="mb-3">
              <b-row>
                <template v-for="(image, index) in getPhotos">
                  <div class="position-relative w-auto h-auto">
                    <button
                      @click="showConfirmDelete(image)"
                      type="button"
                      class="close position-absolute top-0 end-0"
                      style="right: 5px; z-index: 100; top: -10px"
                      aria-label="Close"
                    >
                      <span
                        style="font-size: 30px; color: red"
                        aria-hidden="true"
                        >&times;</span
                      >
                    </button>
                    <!-- v-if="image.details.type.includes('image/')" -->
                    <!-- {{ image.details.content_type }} -->
                    <b-avatar
                      :key="index"
                      class="avatar mr-2"
                      size="5rem"
                      :src="image.details.file"
                      v-if="image.details.content_type.includes('image/')"
                    />
                    <p v-else>{{ image.details.name }}</p>
                  </div>
                </template>
              </b-row>
            </b-container>

            <b-container class="test w-100">
              <!-- <b-row>
                <button @click="$refs.uploadImage.click()">
                  <b-avatar
                    variant="info"
                    size="4rem"
                    @click="$refs.file.click()"
                    src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/9e/Plus_symbol.svg/500px-Plus_symbol.svg.png"
                  >
                  </b-avatar>
                </button>
              </b-row>
              <b-row>
                <h3>OR</h3>
              </b-row> -->
              <b-row>
                <drag-and-drop-files
                  :files-accepted="filesAccepted"
                  @append-files="appendFiles"
                />
              </b-row>
            </b-container>

            <!-- <input
              type="file"
              @change="onFileChange"
              style="display: none"
              ref="uploadImage"
            /> -->
          </b-container>
        </b-col>
      </b-row>
    </b-container>
    <template v-if="item.engineering_required">
      <b-container fluid="xs" class="mb-4">
        <b-row>
          <b-col class="text-right pr-0">Note: </b-col>
          <b-col cols="10">
            <b>Include Marked up Plan if Required</b>
          </b-col>
        </b-row>
      </b-container>
      <br />
      <o-widget-wrapper
        :schema="schema"
        name="use_generic"
        :validators="$v.item"
        :server-errors="_se"
        :form-state="formState"
      >
        <o-checkbox
          v-model="item.use_generic"
          :form-state="formState"
          name="use_generic"
          :validators="$v.item"
          :server-errors="_se"
          v-bind="schema.fields.use_generic"
        ></o-checkbox>
      </o-widget-wrapper>
      <o-widget-wrapper
        :schema="schema"
        name="need_recharge"
        :validators="$v.item"
        :server-errors="_se"
        :form-state="formState"
      >
        <o-checkbox
          v-model="item.need_recharge"
          :form-state="formState"
          name="need_recharge"
          :validators="$v.item"
          :server-errors="_se"
          v-bind="schema.fields.need_recharge"
        ></o-checkbox>
      </o-widget-wrapper>
    </template>
    <o-widget-wrapper
      :schema="schema"
      name="measurements_checked"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-checkbox
        v-model="item.measurements_checked"
        :form-state="formState"
        name="measurements_checked"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.measurements_checked"
      ></o-checkbox>
    </o-widget-wrapper>
  </o-form-wrapper>
</template>

<script>
import schema from "../../schema/index";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
  VuelidateMixin,
} from "../../../vue-ocom/mixins";
import { validationMixin } from "vuelidate";
import { HasGroupMixin } from "../../../vue-ocom/auth/mixin/AuthFormMixins.js";

import OWidgetWrapper from "../../../vue-ocom/components/forms/OWidgetWrapper";
import OTextField from "../../../vue-ocom/components/forms/fields/OTextField";
import OMoneyField from "../../components/money_field/OMoneyField";
import OTextArea from "../../../vue-ocom/components/forms/fields/OTextarea";
import OSelect from "../../../vue-ocom/components/forms/fields/OSelect";
import OCheckbox from "../../../vue-ocom/components/forms/fields/OCheckbox";
import OFormWrapper from "../../../vue-ocom/components/forms/OFormWrapper";
import ODateTime from "../../../vue-ocom/components/forms/fields/ODateTime";
import ONotesTable from "../../../vue-ocom/components/table/common/ONotesTable";

import { default as JobForm } from "../../job/components/ItemForm";
import { default as SupervisorForm } from "../../supervisor/components/ItemForm";
import { default as CustomerForm } from "../../customer/components/ItemForm";
import { default as SupplierForm } from "../../supplier/components/ItemForm";
import { default as CrewForm } from "../../supplier/components/ItemForm";
import { default as CodeRepairTypeFormTable } from "../../code_repair_type/components/ItemFormTable";
// import { default as CodeRepairTypeFormCards } from '../../code_repair_type/components/ItemFormCards';
// import { default as FileUploadFormTable } from '../../file_upload/components/ItemFormTable';
// import { default as FileUploadFormCards } from '../../file_upload/components/ItemFormCards';
import { default as RepairMaterialsUsedFormTable } from "../../repair_materials_used/components/ItemFormTable";
import { default as FileUploadFormTable } from "../../../app/file_upload/components/ItemFormTable";
// import { default as RepairMaterialsUsedFormCards } from '../../repair_materials_used/components/ItemFormCards';
// import { default as NoteFormTable } from '../../note/components/ItemFormTable';
// import { default as NoteFormCards } from '../../note/components/ItemFormCards';
import { default as BillFormTable } from "../../bill/components/ItemFormTable";
// import { default as BillFormCards } from '../../bill/components/ItemFormCards';
import { default as InvoiceFormTable } from "../../invoice/components/ItemFormTable";
// import { default as InvoiceFormCards } from '../../invoice/components/ItemFormCards';
import { default as JobSearch } from "../../components/job_search/JobSearch";
import { default as EmailFiles } from "../../components/email_files/EmailFiles";
import { default as DragAndDropFiles } from "../../components/drag_and_drop_files/DragAndDropFiles";
import OSection from "../../../vue-ocom/components/layout/OSection";
import FList from "@/vue-forms247/app/components/FList";
import { default as CodeCategoryOfWorkForm } from "../../code_category_of_work/components/ItemForm";
import { CalculateTotalRepairs } from "@/app/service_repair/utils.js";
import { mapActions, mapMutations } from "vuex";
import OWorkingOverlay from "../../../vue-ocom/components/OWorkingOverlay";
import Swal from "sweetalert2";
import store from "@/app/components/store.js";
import moment from "moment";
import CrewSupplierMixin from "@/mixins/CrewSupplierMixin";
import { FILE_UPLOAD_EXT_FILES } from "@/upload_file_ext";

export default {
  mixins: [
    HasGroupMixin("Administrator"),
    VuelidateMixin,
    validationMixin,
    CreateFormStateMixin("$v"),
    CreateGroupPermissionMixin("ServiceRepair"),
    CreateCodeTableFetchMixin([
      "Supervisor",
      "Customer",
      "Supplier",
      "CodeFileType",
      "User",
      "CodeCategoryOfWork",
    ]),
    CrewSupplierMixin(),
  ],
  components: {
    DragAndDropFiles,
    OWorkingOverlay,
    FList,
    OSection,
    OFormWrapper,
    OWidgetWrapper,
    ODateTime,

    OCheckbox,
    OSelect,
    OTextField,
    OTextArea,
    OMoneyField,
    JobForm,
    SupervisorForm,
    CustomerForm,
    SupplierForm,
    SupplierForm,
    CrewForm,
    CrewForm,
    CodeRepairTypeFormTable,
    //CodeRepairTypeFormCards,
    FileUploadFormTable,
    //FileUploadFormCards,
    RepairMaterialsUsedFormTable,
    //RepairMaterialsUsedFormCards,
    //NoteFormTable,
    //NoteFormCards,
    BillFormTable,
    //BillFormCards,
    InvoiceFormTable,
    //InvoiceFormCards,
    ONotesTable,
    JobSearch,
    EmailFiles,
    CodeCategoryOfWorkForm,
  },
  props: {
    jobItem: { type: Number | String, default: null },

    item: { type: Object, default: () => {} },
    level: { type: Number, default: 0 },
    inModal: { type: Boolean, default: false },
    create: { type: Boolean, default: false },
  },
  data: () => ({
    working: false,
    selectedJob: null,
    total_cost_of_repair_gst: null,
    total_cost_of_repair_inc_gst: null,
    schemaModel: cleanUpModel(schema.ServiceRepair, {}),
    moneySymbol: "$",
    parentId: 0,
    parentType: "service_repair",
    upload_file_type: 6,
    files: [],
    isDragging: false,
    filesAccepted: FILE_UPLOAD_EXT_FILES,
  }),
  methods: {
    ...mapMutations(["showMessage"]),
    ...mapActions("JobModule", { jobGetById: "getById" }),
    appendFiles(file) {
      this.item.repair_files.push(file);
      if (this.item.id && this.item.job && this.item.description) {
        this.formState.invalid = false;
        this.formState.dirty = true;
      }
      // this.formState.invalid && this.formState.dirty
    },
    showSuccessfullyDeleted(filename) {
      Swal.fire({
        position: "center",
        icon: "success",
        title: "File Deleted!",
        text: "We removed the file: " + filename,
      }).then(function () {
        // Noop!
      });
    },
    refresh() {
      var parent = {
        parent_id: this.parentId,
        parent_type: this.parentType,
      };
      store.dispatch("get_files", parent).then((results) => {
        this.files = results.results;
      });
    },
    changed(items) {
      if (this.validator) {
        this.validator.$touch();
      }

      if (this.formState) this.formState.dirty = true;

      this.$emit("changed", items);
    },
    removeItem(item) {
      var items = _.filter(this.items || [], function (f) {
        if (f !== item) {
          return f;
        }
      });
      const filterPhotos = this.item.repair_files.filter(
        (photo) => photo.id != item.id
      );
      this.item.repair_files = filterPhotos;
      this.changed(items);
    },
    showConfirmDelete(item) {
      const vm = this;
      Swal.fire({
        position: "center",
        icon: "warning",
        title: "Are you sure?",
        text: "Remove this file " + item.details.name + "?",

        confirmButtonText: "Yes, delete it!",
        confirmButtonColor: "#ff5349",
        showCancelButton: true,
        cancelButtonText: "Cancel",
        cancelButtonColor: "#999999",
      }).then(function (isConfirm) {
        if (isConfirm["value"]) {
          // vm.deleteFileUploadItem(item).then(() => { //this function is missing in the vue-ocom, it works before
          vm.removeItem(item);
          // vm.getAllFileUpload();
          vm.refresh();
          // });
          vm.showSuccessfullyDeleted(item.details.name);
        }
      });
    },
    reload(data) {
      this.$emit("reload");
    },
    // async onFileChange(e) {
    //   // this.url = URL.createObjectURL(file);
    //   // this.images.push(URL.createObjectURL(file));
    //   const file = e.target.files[0]; //this is the file
    //   const data = {
    //     parentId: this.parentId,
    //     parentType: this.parentType,
    //     upload_file_type: this.upload_file_type,
    //     upload_file: file,
    //   };
    //   const items = await uploadFile(data);
    //   this.item.repair_files.push(items);
    //   this.$refs["uploadImage"].reset();
    // },
    getSelectedJob(id) {
      this.working = true;
      this.jobGetById(id).then((response) => {
        this.updateJob(response);
        this.selectedJob = response;
        this.working = false;
      });
    },
    updateJob(e) {
      this.item.job = e.id;
      this.item.site_address = e.site_address;
      this.item.suburb = e.suburb;

      if (e.customer) {
        this.item.builder = e.customer;
        this.item.builder__name = e.customer__name;
      }

      if (e.crew_supplier) {
        if (!this.item.crew_supplier) {
          // Could be changed by user.
          this.item.crew_supplier = e.crew_supplier;
        }
        // var original_crew = $scope.options.crews_by_id[item.crew_supplier];
        var original_crew = this.optionCrewItemsById[e.crew_supplier];
        if (original_crew) {
          this.item.job_crew_name = original_crew.name;
        }
      }
    },
    compute_labour_total_cost() {
      CalculateTotalRepairs(this.item);

      this.total_cost_of_repair_gst = this.item.total_cost_of_repair_gst;
      this.total_cost_of_repair_inc_gst = this.item.total_cost_of_repair_inc_gst;
    },
  },
  computed: {
    getCurrentDate() {
      if (!this.item.date_received) {
        const date = moment().format("YYYY-MM-DD");
        this.item.date_received = date;
      }

      return this.item.date_received;
    },
    getSupervisor() {
      if (!this.item.supervisor) {
        this.item.supervisor = this.currentUser.role.supervisor;
      }
      return this.item.supervisor;
    },
    getPhotos() {
      return this.item.repair_files;
    },
    checkLabourHourRate() {
      return this.item.labour_hour_rate;
    },
    checkLabourHours() {
      return this.item.labour_hours;
    },
    checkLabourTotalCost() {
      return this.item.labour_total_cost;
    },
    _se() {
      // Return an empty Object if there are no Server Errors to avoid Binding Errors
      return this.serverErrors || {};
    },
  },
  watch: {
    checkLabourHourRate() {
      this.compute_labour_total_cost();
    },
    checkLabourHours() {
      this.compute_labour_total_cost();
    },
    checkLabourTotalCost() {
      this.compute_labour_total_cost();
    },
  },
  created() {
    this.compute_labour_total_cost();

    if (this.jobItem) {
      this.getSelectedJob(this.jobItem);
    }
  },
};
</script>
